import { env } from '../env';
import { ProgressVariant } from './svidashboard-progress.manifest';

export interface ITimelapseFrame {
  year: number;
  quarter: number;
  title: string;
  date: string | null;
  url: string;
  key: string;
}

export function isTiffDashboardKey(key: string): boolean {
  return /\.tiff?$/i.test(key);
}

export function buildDashboardImageDisplayUrl(
  objectId: string,
  year: number,
  quarter: number,
  toggle: boolean,
): string {
  const params = new URLSearchParams({
    objectId,
    year: String(year),
    quarter: String(quarter),
    toggle: String(toggle),
  });
  return `${env.REACT_APP_SERVER_URL}/svidashboard/image/display?${params.toString()}`;
}

export function buildProgressImageDisplayUrl(
  objectId: string,
  year: number,
  quarter: number,
  variant: ProgressVariant,
): string {
  const params = new URLSearchParams({
    objectId,
    year: String(year),
    quarter: String(quarter),
    variant,
  });
  return `${env.REACT_APP_SERVER_URL}/svidashboard/progress-image/display?${params.toString()}`;
}

export function resolveProgressImageUrl(
  key: string,
  presignedUrl: string,
  objectId: string,
  year: number,
  quarter: number,
  variant: ProgressVariant,
): string {
  if (isTiffDashboardKey(key)) {
    return buildProgressImageDisplayUrl(objectId, year, quarter, variant);
  }
  return presignedUrl;
}

export function resolveTimelapseFrameSrc(
  frame: ITimelapseFrame,
  objectId: string,
): string {
  if (isTiffDashboardKey(frame.key)) {
    return buildDashboardImageDisplayUrl(objectId, frame.year, frame.quarter, false);
  }
  return frame.url;
}
